import { useQuery } from 'react-query';

import { applianceQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import useQSBuilder from '../../hooks/useQSBuilder';
import { IApplianceSelection } from '../../types/Appliance/Appliance';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useSuperAdminApplianceManufacturers(
  hardwareTypeId?: string
) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const superAdminApplianceManufacturers = useQuery({
    queryKey: applianceQueryKeys.superAdminManufacturers(hardwareTypeId),
    queryFn: () =>
      get<IDefaultResponseWithData<IApplianceSelection>>(
        `/v1/superadmin/hardware/manufacturers${buildQs({ hardwareTypeId })}`
      ).then((res) => res.data.data),
  });

  return {
    superAdminApplianceManufacturers,
  };
}
